import React from 'react'

import { image_placeholder_url } from '../globals'


interface ownProps {
  website: string | null,
  image_src?: string | null,
  name: string,
  class_name: string,
  affiliazione?: string,
  size: number
  showAffiliazione: boolean
  logo_scuola?: string | null,
}


const foto_rotonda_style = (size: number, count: number) => {
  return {
    margin: '0 auto',
    marginBottom: '0.75em',
    width: `${size * count}vw`,
    height: `${size}vw`,
    borderRadius: `${size / 2}vw`,
  }
}



const FotoContributor = ({ website, image_src, name, class_name, affiliazione, size, showAffiliazione, logo_scuola }: ownProps) => {
  const real_image_src = image_src ? image_src : image_placeholder_url;
  const count = !!logo_scuola ? 2 : 1;

  return (
    <div className="bannerino flex-grow-1">
      <a href={!!website ? website : undefined} className={class_name} style={{
        display: "flex",
        flexDirection: "row",
        ...foto_rotonda_style(size, count)
      }}>
        <img
          src={real_image_src}
          className="img-thumbnail"
          alt={name}
          style={{ maxWidth: '100%', maxHeight: '100%', borderRadius: `${size / 2}vw` }}
        />
        {!!logo_scuola &&
          <img
            src={logo_scuola}
            className="img-thumbnail"
            alt={name}
            style={{ maxWidth: '100%', maxHeight: '100%', borderRadius: `${size / 2}vw` }}
          />
        }
      </a>
      <h4 className="text-row text-center">
        {website ?
          <a href={website}>
            {name}
          </a>
          :
          <>{name}</>
        }
      </h4>
      {showAffiliazione && <p className="text-muted">{affiliazione}</p>}
    </div>
  )
}

export default FotoContributor
